import { render, staticRenderFns } from "./TilesTransform.vue?vue&type=template&id=96a0ff20&scoped=true&"
import script from "./TilesTransform.vue?vue&type=script&lang=js&"
export * from "./TilesTransform.vue?vue&type=script&lang=js&"
import style0 from "./TilesTransform.vue?vue&type=style&index=0&id=96a0ff20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a0ff20",
  null
  
)

export default component.exports